import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "../components/ui/button";
import { LOGO_URL, NAV_LINKS, CONTACT } from "../lib/constants";

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-[#cbd5e1]/70 shadow-[0_1px_0_rgba(10,37,64,0.04)]">
      {/* Top contact strip */}
      <div className="hidden md:block bg-[#0a2540] text-white/90 text-xs">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-9">
          <div className="flex items-center gap-6">
            <span className="flex items-center gap-2"><Phone className="w-3.5 h-3.5" /> {CONTACT.phone}</span>
            <span className="text-white/70">{CONTACT.hours}</span>
          </div>
          <div className="text-[#d4af37] tracking-[0.2em] uppercase text-[10px] font-semibold">
            One Umbrella · Endless Possibilities
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" data-testid="header-logo-link" className="flex items-center gap-3">
            <img src={LOGO_URL} alt="HSA Service Hub" className="h-12 w-12 object-cover rounded-md" />
            <div className="leading-tight">
              <div className="font-serif-hsa text-xl font-bold text-[#0a2540]">HSA Service Hub</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-[#1e6dd8] font-semibold">Business · Financial · Insurance · Legal</div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {NAV_LINKS.slice(0, 9).map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `px-3 py-2 text-sm font-medium transition-colors ${
                    isActive ? "text-[#0a2540]" : "text-slate-600 hover:text-[#1e6dd8]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <Link to="/contact" className="hidden md:inline-flex">
              <Button
                data-testid="header-book-consultation-btn"
                className="bg-[#d4af37] hover:bg-[#b8951f] text-[#0a2540] font-semibold rounded-full px-5"
              >
                Book Consultation
              </Button>
            </Link>
            <button
              data-testid="mobile-menu-toggle"
              className="lg:hidden text-[#0a2540] p-2"
              onClick={() => setOpen(!open)}
              aria-label="Toggle menu"
            >
              {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden border-t border-[#cbd5e1]/70 bg-white">
          <div className="px-6 py-4 flex flex-col gap-1 max-h-[70vh] overflow-y-auto">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `px-3 py-3 text-sm font-medium rounded ${
                    isActive ? "bg-[#f8f9fa] text-[#0a2540]" : "text-slate-700"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/contact" onClick={() => setOpen(false)}>
              <Button data-testid="mobile-book-consultation-btn" className="w-full mt-2 bg-[#d4af37] hover:bg-[#b8951f] text-[#0a2540] font-semibold">
                Book Consultation
              </Button>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
